<template>

  <!-- Gallery -->
  <div
    v-if="firstId"
    class="gallery"
    :style="{height}">

    <q-carousel
      padding
      infinite
      animated
      :value="id"
      height="100%"
      :arrows="slides.length > 1"
      @input="selectedId = $event"
      transition-next="slide-left"
      transition-prev="slide-right"
      prev-icon="fa lni-chevron-left"
      next-icon="fa lni-chevron-right"
      :style="{backgroundColor: color}">

      <template
        v-for="slide in slides">

        <gallery-image-slide
          :slide="slide"
          :key="slide.id"
          :name="slide.id"
          v-if="simpleFileType(slide) === 'image'"/>

        <gallery-video-slide
          :slide="slide"
          :color="color"
          :key="slide.id"
          :name="slide.id"
          v-if="simpleFileType(slide) === 'video'"/>

      </template>

    </q-carousel>

  </div>

</template>

<script>

  import SimpleFileTypeMixin from '@src/mixins/simple-file-type-mixin';
  import GalleryVideoSlide from '@src/components/gallery/gallery-video-slide';
  import GalleryImageSlide from '@src/components/gallery/gallery-image-slide';

  export default {
    name: 'gallery',
    mixins: [
      SimpleFileTypeMixin,
    ],
    props: {
      slides: {
        type: Array,
        default: () => [],
      },
      height: {
        type: [String, Number],
        default: 420,
      },
      color: {
        type: String,
        default: undefined,
      },
    },
    components: {
      GalleryImageSlide,
      GalleryVideoSlide,
    },
    data() {
      return {
        selectedId: undefined,
      };
    },
    computed: {
      id() {

        const found = this.slides.find(
          v => v.id === this.selectedId,
        );

        return found
          ? this.selectedId
          : this.firstId;
      },
      firstId() {

        return this.slides
          && this.slides.length
          && this.slides[0].id;
      },
    },
    beforeMount() {

      this.$emit(
        'input',
        this.id,
      );
    },
    watch: {
      id(value) {

        this.$emit(
          'input',
          value,
        );
      },
    },
  };

</script>

<style lang="scss">

  .gallery {

    .q-carousel {
      max-height: 100%;
      min-height: 100%;
      background-color: white;
    }

    .q-panel {
      overflow: hidden !important;
    }

    .q-carousel__arrow button {
      opacity: .7;
      padding: .4rem;
      transition: opacity .2s linear;
    }

    .q-carousel:hover .q-carousel__arrow button {
      opacity: 1;
    }

    .q-carousel__prev-arrow {
      left: 1rem;
    }

    .q-carousel__prev-arrow i {
      left: -3px;
    }

    .q-carousel__next-arrow {
      right: 1rem;
    }

    .q-carousel__next-arrow i {
      right: -3px;
    }

    .q-carousel__prev-arrow i,
    .q-carousel__next-arrow i {
      color: white;
      font-size: 38px;
    }
  }

</style>
